<template>
  <div id="app" :class="$root.template">
    <div v-if="$root.isLoading" class="loading">
      <div class="loading-box">

        <div class="loading-effect" style="top: 49%;left: 50%;">
          <!-- <div class="icon-button" :style="{ 'background-image': 'url(' + logo + ')' }" style="height: 3.5rem;width: 3.5rem;">
          </div> -->
        </div>
        <div class="loading-effect">
          <b-spinner style="width: 5rem; height: 5rem;" label="Large Spinner">

          </b-spinner>

        </div>
        <div class="loading-effect" style="top: 80%;">
          {{ $t('loading...') }}

        </div>
      </div>
    </div>
    <router-view></router-view>

    <!-- <b-sidebar id="sidebar-menu">

    </b-sidebar> -->
    <ModalError></ModalError>
  </div>
</template>

<script>
import ModalError from './errorMsg.vue';
export default {
  components: { ModalError },
  async mounted() {
    this.$root.getGame();
    // const agentCode = await localStorage.getItem("agentCode") || "guest";
    // const correctedPath = this.$route.fullPath.replace('guest', `${agentCode}`);

    // console.log(agentCode);
    // console.log(correctedPath);
  }
}
</script>
